// React Imports
import * as React from "react";
import {useDispatch, useSelector} from "react-redux";
import {useState} from "react";

// Mui Imports
import DoNotTouchIcon from "@mui/icons-material/DoNotTouch";
import FlagIcon from "@mui/icons-material/Flag";
import Brightness1Icon from "@mui/icons-material/Brightness1";
import Divider from "@mui/material/Divider";
import ThumbDownIcon from "@mui/icons-material/ThumbDown";
import IconButton from "@mui/material/IconButton";
import UndoIcon from '@mui/icons-material/Undo';
import ThumbUpOffAltIcon from '@mui/icons-material/ThumbUpOffAlt';
import ThumbDownOffAltIcon from '@mui/icons-material/ThumbDownOffAlt';
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
import EmojiFlagsIcon from '@mui/icons-material/EmojiFlags';
import PanToolIcon from '@mui/icons-material/PanTool';
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import {Avatar, ListItemIcon, ListItemText, Tooltip} from "@mui/material";
import DoneOutlineIcon from '@mui/icons-material/DoneOutline';
import BookmarkIcon from '@mui/icons-material/Bookmark';
import BookmarkBorderIcon from '@mui/icons-material/BookmarkBorder';
import ThumbUpIcon from "@mui/icons-material/ThumbUp";

// App Imports
import ApproveContract from "./ContractStatusActions/ApproveContract";
import UnapproveContract from "./ContractStatusActions/UnapproveContract";
import FinalizeContract from "./ContractStatusActions/FinalizeContract";
import HoldContract from "./ContractStatusActions/HoldContract";
import RemoveHoldContract from "./ContractStatusActions/RemoveHoldContract";
import TagContract from "./ContractStatusActions/TagContract";
import UnTagContract from "./ContractStatusActions/UnTagContract";
import DeferContract from "./ContractStatusActions/DeferContract";
import RejectContract from "./ContractStatusActions/RejectContract";
import ApprovedContractAvatar from "./ContractStatusAvatars/ApprovedContractAvatar";
import NoContractAvatar from "./ContractStatusAvatars/NoContractAvatar";
import SubmittedContractAvatar from "./ContractStatusAvatars/SubmittedContractAvatar";
import FinalizedBadContractAvatar from "./ContractStatusAvatars/FinalizedBadContractAvatar";
import FinalizedGoodContractAvatar from "./ContractStatusAvatars/FinalizedGoodContractAvatar";
import UnapprovedBadContractAvatar from "./ContractStatusAvatars/UnapprovedBadContractAvatar";
import UnapprovedGoodContractAvatar from "./ContractStatusAvatars/UnapprovedGoodContractAvatar";
import DeferredContractAvatar from "./ContractStatusAvatars/DeferredContractAvatar";
import RejectedContractAvatar from "./ContractStatusAvatars/RejectedContractAvatar";
import FlaggedContractAvatar from "./ContractStatusAvatars/FlaggedContractAvatar";
import HeldContractAvatar from "./ContractStatusAvatars/HeldContractAvatar";
import RollupMissingInputMissingContractAvatar from "./ContractStatusAvatars/RollupMissingInputMissingContractAvatar";
import SeriesMissingContractAvatar from "./ContractStatusAvatars/SeriesMissingContractAvatar";
import ContractTypeMissingContractAvatar from "./ContractStatusAvatars/ContractTypeMissingContractAvatar";
import MultiBadContractAvatar from "./ContractStatusAvatars/MultiBadContractAvatar";
import MultiGoodContractAvatar from "./ContractStatusAvatars/MultiGoodContractAvatar";
import EmptyContractAvatar from "./ContractStatusAvatars/EmptyContractAvatar";


// main function
export default function ContractStatusMenu({ rowContractData }) {


    // ****************** BEGIN STATES ****************************

    const [anchorEl, setAnchorEl] = React.useState(null);
    const [owedStatus, setOwedStatus] = useState(null);

    // ****************** END STATES ****************************


    // *********************** BEGIN STORE ********************************


    const selectorContractList = useSelector((state) => state.workQueueSlc.value.mousedContractContractList);
    // const contractArray = selectorContractList
    //     .split(',')           // splits into ["1","2","3"]
    //     .map(Number);         // converts each element to integer
    // const contractArray = useSelector((state) => state.workQueueSlc.value.mousedContractContractIdArray);

    // ********************** END STORE ********************************


    // ****************** BEGIN DISPATCH ****************************



    // ****************** END DISPATCH ****************************


    // ***************** BEGIN CONTROLS ***************************

    // const cdpList = props.selectedCdps;
    // https://www.geeksforgeeks.org/how-to-correctly-use-axios-params-with-arrays-in-javascript/
    // const URLString = selectorContractDataPointId.map((value, index) => `arr[${index}]=${value}`).join('&');


    const handleCrudMenuOpen = (event) => {
        console.log("this should be the index");
        console.log("rowContractData");
        console.log(rowContractData);
        // console.log(event.currentTarget.index);
        setAnchorEl(event.currentTarget);
    };


    const handleMenuClose = () => {
        setAnchorEl(null);
    };


    // *************** END CONTROLS *******************************


    // ***************** BEGIN MENU ***************************

    const isMenuOpen = Boolean(anchorEl);

    const crudId = 'primary-search-account-menu';

    const renderMenu = (

        <Menu
            anchorEl={anchorEl}
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            id={crudId}
            keepMounted
            transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            open={isMenuOpen}
            onClose={handleMenuClose}
        >
            <MenuItem sx={{ justifyContent: 'center', cursor: 'default'  }}>
                <ListItemText primary="Change Status" sx={{ textAlign: 'center' }} />
            </MenuItem>
            <Divider/>


            < ApproveContract onMenuClose={handleMenuClose}  rowContractData={rowContractData} selectorContractList={selectorContractList} />

            < UnapproveContract onMenuClose={handleMenuClose}  rowContractData={rowContractData} selectorContractList={selectorContractList} />

            < FinalizeContract onMenuClose={handleMenuClose}  rowContractData={rowContractData} selectorContractList={selectorContractList} />

            < HoldContract onMenuClose={handleMenuClose}  rowContractData={rowContractData} selectorContractList={selectorContractList} />

            < RemoveHoldContract onMenuClose={handleMenuClose}  rowContractData={rowContractData} selectorContractList={selectorContractList} />

            < TagContract onMenuClose={handleMenuClose}  rowContractData={rowContractData} selectorContractList={selectorContractList} />

            < UnTagContract onMenuClose={handleMenuClose}  rowContractData={rowContractData} selectorContractList={selectorContractList} />

            < DeferContract onMenuClose={handleMenuClose}  rowContractData={rowContractData} selectorContractList={selectorContractList} />

            < RejectContract onMenuClose={handleMenuClose}  rowContractData={rowContractData} selectorContractList={selectorContractList} />


        </Menu>
    );


    // ****************** BEGIN RETURN ****************************

    return (
        <div>
            <div onClick={handleCrudMenuOpen}>
                < NoContractAvatar rowContractData={rowContractData} />
                < ApprovedContractAvatar rowContractData={rowContractData}  />
                < SubmittedContractAvatar rowContractData={rowContractData}  />
                < FinalizedBadContractAvatar rowContractData={rowContractData}  />
                < FinalizedGoodContractAvatar rowContractData={rowContractData}  />
                < UnapprovedBadContractAvatar rowContractData={rowContractData}  />
                < UnapprovedGoodContractAvatar rowContractData={rowContractData}  />
                < DeferredContractAvatar rowContractData={rowContractData}  />
                < RejectedContractAvatar rowContractData={rowContractData}  />
                {/*< FlaggedContractAvatar rowContractData={rowContractData} />*/}
                < HeldContractAvatar rowContractData={rowContractData} />
                < RollupMissingInputMissingContractAvatar rowContractData={rowContractData} />
                < SeriesMissingContractAvatar rowContractData={rowContractData} />
                < ContractTypeMissingContractAvatar rowContractData={rowContractData} />
                < MultiBadContractAvatar rowContractData={rowContractData} />
                < MultiGoodContractAvatar rowContractData={rowContractData} />
                < EmptyContractAvatar rowContractData={rowContractData} />
                {/*{getAvatar(rowContractData)}*/}
            </div>
            {renderMenu}
        </div>
    );

    // ****************** END RETURN ****************************

}